import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/rePi", // url = base url + request url
    timeout: 10000,
});
export default service;
